import { ColDef } from 'ag-grid-community';

import { GridService } from 'tms-lib';

export function getCollectionProductColumnDefs(gridService: GridService): ColDef[] {
  return [
    // The bunch's own code and description lead: it is what the customer orders by, and it
    // often differs from the product key shown alongside it.
    gridService.text('alternativeRef', $localize`Bunch Code`),
    gridService.text('alternativeDescription', $localize`Bunch Description`),
    gridService.text('productKey', $localize`Product`),
    gridService.text('productDescription', $localize`Description`),
    gridService.text('collectionKey', $localize`Collection`),
    gridService.text('collectionDescription', $localize`Collection Description`),
  ];
}
